import React, {Fragment} from 'react';
import {EuiDescribedFormGroup, EuiLink, EuiPanel, EuiSpacer} from "@elastic/eui";
import OrderFormActionsSelector from "./order-form-actions-selector";
import OrderFormBeneficiaryIdInfo from "./order-form-beneficiary-id-info";

type OrderFormPayNotesProps = {
    FormActions: any[],
    ShowAction: boolean,
    ShowBeneficiaryInfoFields: boolean,
    OnActionChanged : (value:any)=>void
}
const OrderFormPayNotes = ({ShowAction, FormActions, ShowBeneficiaryInfoFields,OnActionChanged}: OrderFormPayNotesProps) => {
    return (
        <Fragment>
            <OrderFormActionsSelector Actions={FormActions} ShowAction={ShowAction} OnChange={OnActionChanged}/>
            <EuiSpacer/>
            {
                (ShowBeneficiaryInfoFields) ?
                    (<Fragment>

                        <EuiPanel>
                            <EuiDescribedFormGroup
                                title={<h3>Pay Notes</h3>}
                                description={
                                    <Fragment>
                                        Fill notes about the Beneficiary details when
                                        paying this order can have{" "}
                                        <EuiLink
                                            href="http://www.elastic.co"
                                            target="_blank"
                                        >
                                            links
                                        </EuiLink>{" "}
                                        or any other type of content.
                                    </Fragment>
                                }>
                                <OrderFormBeneficiaryIdInfo/>
                            </EuiDescribedFormGroup>
                        </EuiPanel>
                        <EuiSpacer/>
                    </Fragment>) : null}

        </Fragment>
    );
};

export default OrderFormPayNotes;